import {  LOADER_MESSAGE, PAGINATION_INFO } from './../constant/ActionTypes';

export const commonReducer = (state, action) => {
    switch (action.type) {
        case LOADER_MESSAGE:
            return { ...state, loaderMsg: action.payload };
        case PAGINATION_INFO:
            return { ...state, pagination: action.payload };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/commonReducer.js